import React, { useRef, useMemo, useCallback, useEffect, useContext } from 'react';
import jwtDecode from 'jwt-decode';
import EditorContext from '../store/Editor.context';
import { resetSession } from '../store';
import useCountdown from '../hooks/useCountdown';
import { millisToMinutesAndSeconds } from '../utils/helpers';
import toast from '../components/shared/Toasts';
import { STORAGE } from '../constants';
import useOptions from '../hooks/useOptions';

var EditorTimeToLeft = function EditorTimeToLeft(_ref) {
  var Component = _ref.component;
  var started = useRef(null);

  var _useContext = useContext(EditorContext),
      dispatch = _useContext.dispatch;

  var _useOptions = useOptions(),
      onExtiredSession = _useOptions.onExtiredSession;

  var _useMemo = useMemo(function () {
    var token = localStorage.getItem(STORAGE.authToken);
    if (!token) return {
      exp: 0
    };
    return jwtDecode(token);
  }, []),
      exp = _useMemo.exp;

  var _useCountdown = useCountdown(function () {
    return (exp - new Date() / 1000) * 1000;
  }, 1000),
      timeLeft = _useCountdown[0],
      _useCountdown$ = _useCountdown[1],
      start = _useCountdown$.start,
      reset = _useCountdown$.reset;

  var handleVisibilityChange = useCallback(function () {
    if (document.hidden) {
      started.current = false;
      reset();
    } else {
      started.current = true;
      start();
    }
  }, []);

  if (started.current && timeLeft <= 0) {
    localStorage.clear();
    started.current = false;
    dispatch(resetSession);
    toast.error({
      description: 'Your token has expired'
    }, {
      toastId: 'token-expired'
    });
    if (onExtiredSession) onExtiredSession();
  }

  useEffect(function () {
    start();
    started.current = true;
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return function () {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    id: "time-to-left",
    className: "inline-flex"
  }, Component ? /*#__PURE__*/React.createElement(Component, null, millisToMinutesAndSeconds(timeLeft)) : /*#__PURE__*/React.createElement("div", {
    className: "inline-flex w-16 items-center justify-center px-2 py-2 rounded-md text-sm font-medium leading-5 bg-primary-light text-primary"
  }, millisToMinutesAndSeconds(timeLeft)));
};

export default EditorTimeToLeft;